module.exports = __webpack_public_path__ + "static/media/quote-icon-pages.06ea0a41.svg";